module.exports = __webpack_public_path__ + "media/images/profile-01-p-130x130q80-6146978959754262865267614cb870d2.png";